import api from "@/services/api.service";

export default {
    name: "list",
    components: {},
    props: {
        caption: {
            type: String,
            default: "Campaign list"
        },
        hover: {
            type: Boolean,
            default: true
        },
        striped: {
            type: Boolean,
            default: true
        },
        bordered: {
            type: Boolean,
            default: false
        },
        small: {
            type: Boolean,
            default: false
        },
        fixed: {
            type: Boolean,
            default: false
        }
    },
    data() { 
        return {
            index: 1,
            mode: "multi",
            icon: 'fa fa-sort',
            selcol: '',
            items: [],
            fields: [
                { key: "#" },
                { key: "name", sortable: false },
                { key: "type", sortable: false },
                { key: "date", sortable: false },
                // { key: "status", sortable: true },
                { key: "actions" }
            ],
            sech: {},
            currentPage: 1,
            currentSortDir:'desc',            
            perPage: 10,
            totalRows: null,
            totalCampaign: null,
            isBusy: true,
            delete_ids: [],
            allSelected: false,
            imageUrl: process.env.VUE_APP_IMAGE_URL,
            colName : '',   
            permission_list: false,
            permission_add: false,
            permission_delete: false,
            permission_edit: false,       
            permission_download: false,
            superAdmin: false
        };
    },
    computed: {},
    mounted() { },
    created() {
        this.getCampaign();
        this.getUserPermissions();
    },
    watch: {
        currentPage: {
            handler: function (page) {
                // this.getCampaign(page);
                this.toSort(this.colName,page);                
            }
        }
    },
    methods: {
        makeToast(message = "", title = "Alert", variant = "warning") {
            this.toastCount++;
            this.$root.$bvToast.toast(message, {
                title: title,
                variant: variant,
                autoHideDelay: 3000
            });
        },
        selectAll: function (e) {
            this.delete_ids = [];
            if (e.target.checked) {
                for (var item in this.items) {
                    this.delete_ids.push(this.items[item].id.toString());
                }
            }
        },
        selectOne() {
            this.allSelected = false;
        },
        async getUserPermissions(){
            let response = await api.post("users/user-permissions");
            const permissions = [];
            if (response.status == "success") {
              response.data[0].permission.forEach( function(element) {                
                  permissions.push(element.action)
              }.bind(this));
              this.permission_list = permissions.includes("list_campaign");
              this.permission_add = permissions.includes("add_campaign");
                if(this.permission_list == true || this.permission_add == true){
                    this.permission_edit = permissions.includes("edit_campaign");
                    this.permission_delete = permissions.includes("delete_campaign");  
                    this.permission_download = permissions.includes("download_asset_campaign");  
                }else if(response.data[0].role == 'super_admin'){
                    this.superAdmin = true;
                } else{
                    this.makeToast("Permission denied","Alert","warning",6000);
                    this.$router.push({name: 'Admin Dashboard'});
                }
            }      
        },
        async toSort (items,page = 1)        
        {               
            if(items == "date"){ items = 'created_at'; }
            if (items != "actions" && items != "#") {                
                if(page == 1)
                if(items == this.colName)
                this.currentSortDir = this.currentSortDir==='asc'?'desc':'asc'; 
                
                this.colName = items; 
                this.isBusy = true;                   
                let response = await api.post("campaign/list",{ page:page,columnname:items,sortType:this.currentSortDir,paginateVal:this.perPage});
                if (response.status == "success") {
                    if (response.data != "") {
                        if(this.currentSortDir == 'asc'){
                            this.icon1 = 'fa fa-sort-up';                             
                            this.selcol = items; 
                        } else{ 
                            this.icon1 = 'fa fa-sort-down';                             
                            this.selcol = items;                            
                        }                        
                        this.items = response.data.data;
                        this.totalCampaign = response.data.total;
                        this.currentPage = response.data.current_page;
                        this.perPage = response.data.per_page;
                    } else {
                        this.items = [];
                    }
                }
               this.isBusy = false;   
            }            
        },
        deleteMultiple() {
            this.$bvModal
                .msgBoxConfirm("Are you sure want to delete multiple campaigns?")
                .then(value => {
                    if (value) {
                        this.deleteCampaign(this.delete_ids, 0);
                    } else {
                        return;
                    }
                })
                .catch(function () {
                    return;
                });

        },

        async getCampaign(page) {
            this.isBusy = true;   
            this.sech.page = page;
            let response = await api.post("campaign/list", this.sech);
            if (!response)
                this.makeToast("Something went to wrong please try again", "Alert", "danger", 6000);
            if (response.status == "success") {
                if (response.data != "") {
                    this.items = response.data.data;
                    this.totalCampaign = response.data.total;
                    this.currentPage = response.data.current_page;
                    this.perPage = response.data.per_page;
                    this.pageOptions.forEach(element => {
                        if(element.value > this.totalCampaign){
                            var indexOf = this.pageOptions.indexOf(element);
                            if( indexOf != 0 )
                            this.pageOptions.splice(indexOf)
                        }
                    });
                    if(this.totalCampaign <= 500)
                    this.pageOptions.push({text:'All',value:this.totalCampaign});
                } else {
                    this.items = [];
                }
            }
            this.isBusy = false;
        },
        getRowCount(items) {
            return items.length;
        },
        campaignLink(id) {
            return `campaign/edit/${id.toString()}`;
        },
        rowClicked(item) {
            const userLink = this.campaignLink(item.id);
            this.$router.push({ path: userLink });
        },
        updateCampaign(item) {
            this.$router.push({
                name: "Edit Campaign",
                params: { id: item.item.id }
            });
        },
        showConfirmBox(id, index) {
            this.$bvModal
                .msgBoxConfirm("Are you sure want to delete this campaign?")
                .then(value => {
                    if (value) {
                        this.deleteCampaign(id, index);
                    } else {
                        return;
                    }
                })
                .catch(function () {
                    return;
                });
        },
        async deleteCampaign(id, index) {
            let response = await api.post("admin/campaign/delete-campaign", {
                id: id
            });
            if (!response)
                this.makeToast(
                    "Something went to wrong please try again",
                    "Alert",
                    "danger",
                    6000
                );

            if (response.status == "success") {
                if (index === 0)
                    this.getCampaign();
                else
                    this.items.splice(index, 1);

                this.makeToast(
                    response.message || `Campaign delete successful.`,
                    "Alert",
                    "success"
                );
            } else this.makeToast(`Campaign not deleted.`, "Alert", "danger");
        },
        showResult() {
            this.$router.push({ name: "Show Result" });
        },
        importContacts(item) {
            this.$router.push({
                name: "Import Contacts",
                params: { id: item.item.id }
            });
        }
    }
};
